import React from "react";
import { Base } from "../../styles";
import styled from "styled-components";
const Content = styled.div`
  width: 100%;
`;
const ContentWrapper = styled(Base)({});
const ContentGutter = ({ children }) => {
  return /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(ContentWrapper, {
    as: "div",
    p: ["0 25px", "0 35px", "0 165px"]
  }, children));
};
export default ContentGutter;
